import type { NavigationGuard } from 'vue-router';

import { getToken } from 'src/logic/services/token.service';
import { useAuthStore } from '../stores/auth.store';

export const notLoggedGuard: NavigationGuard = async (to) => {
  const { getUser, getOnboardingStatus } = useAuthStore();
  const isPublicObjectDetails = to.name === 'object-details';

  const redirectQuery = to.fullPath && to.fullPath !== '/' ? { redirect: to.fullPath } : {};

  if (!getToken()) {
    if (isPublicObjectDetails) return;
    return {
      name: 'signIn',
      query: redirectQuery,
    };
  }

  const isTokenValid = await getUser();
  if (!isTokenValid) {
    if (isPublicObjectDetails) return;
    return {
      name: 'signIn',
      query: redirectQuery,
    };
  }

  const onboardingStatus = await getOnboardingStatus();
  if (isTokenValid && !onboardingStatus && to.name !== 'onboarding') {
    return { name: 'onboarding' };
  }
};
